window.addEventListener("load", (event) => {


  jQuery(window).load(function () {

    /**
     * Force owl carousel to recalculate width of images in quick view
     */
    jQuery('.open-quick-view').click(function () {
      setTimeout(function () {
        window.dispatchEvent(new Event('resize'));
      }, 1000);
    });

  });

  /**
   * Enable or disable the homepage slider depending on viewport width or is full width
   */
  const updateSlider = function () {
    const sliders = jQuery('.pageindex .home-slider');
  
    sliders.each(function() {
      const currentSlider = jQuery(this);
  
      if (jQuery(window).width() <= 768) {
        if (!currentSlider.hasClass('slick-initialized')) {
          currentSlider.slick();
        }
      } else {
        if (currentSlider.hasClass('home-slider--full-width')) {
          if (!currentSlider.hasClass('slick-initialized')) {
            currentSlider.slick();
          }
        } else {
          if (currentSlider.hasClass('slick-initialized')) {
            currentSlider.slick('unslick');
          }
        }
      }
    });
  };

  jQuery(document).ready(updateSlider);
  jQuery(window).resize(updateSlider);

  document.addEventListener("click", function (e) {
    const target = e.target;

    if (target instanceof HTMLElement) {
      if (target.tagName === 'A' && target.parentElement.parentElement.classList.contains('tt-options-swatch') && target.getAttribute('href') === '#' ){

        // GET VALUE
        let value = target.innerHTML;

        // SET IT TO THE URLS
        let colour_urls = document.querySelectorAll('.product__variants--color a');
        colour_urls.forEach(color_box => {

          if(color_box.getAttribute("data-attr-href") === null){
            // HREF ISN'T SAVED YET
            color_box.setAttribute("data-attr-href", color_box.getAttribute('href'))
          }

          let product_href = '';
          product_href = color_box.getAttribute('data-attr-href');

          color_box.setAttribute('href', product_href + '?size=' + value);

        })

      }
    }
  })
  document.addEventListener("touchstart", function (e) {
    const target = e.target;

    if (target instanceof HTMLElement) {
      if (target.tagName === 'A' && target.parentElement.parentElement.classList.contains('tt-options-swatch') && target.getAttribute('href') === '#' ){

        // GET VALUE
        let value = target.innerHTML;

        // SET IT TO THE URLS
        let colour_urls = document.querySelectorAll('.product__variants--color a');
        colour_urls.forEach(color_box => {

          if(color_box.getAttribute("data-attr-href") === null){
            // HREF ISN'T SAVED YET
            color_box.setAttribute("data-attr-href", color_box.getAttribute('href'))
          }

          let product_href = '';
          product_href = color_box.getAttribute('data-attr-href');

          color_box.setAttribute('href', product_href + '?size=' + value);

        })

      }
    }
  })


  // LOADING THE PARAMETERS
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  let size = '';

  if(urlParams.has('size')){
    document.querySelector('a[data-value="'+urlParams.get('size')+'"]').click();
  }
});
